import type { AmplifyAppConfig } from "./types.ts";

const REGION = "eu-central-1";
const STAGE = "prod";

export const productionConfig: AmplifyAppConfig = {
  aws_project_region: REGION,
  aws_cloud_logic_custom: [
    {
      name: "apiFactorsApp",
      endpoint: `https://i0uypymbj6.execute-api.${REGION}.amazonaws.com/${STAGE}`,
      region: REGION,
    },
    {
      name: "apiIndicatorApp",
      endpoint: `https://ts74bbn1ue.execute-api.${REGION}.amazonaws.com/${STAGE}`,
      region: REGION,
    },
    {
      name: "stockpicker",
      endpoint: `https://omm54mpnab.execute-api.${REGION}.amazonaws.com/${STAGE}`,
      region: REGION,
    },
  ],
  aws_dynamodb_all_tables_region: REGION,
  aws_dynamodb_table_schemas: [
    { tableName: "CompanyTable-prod", region: REGION },
    { tableName: "IndicatorTable-prod", region: REGION },
    { tableName: "ModelsTable-prod", region: REGION },
    { tableName: "SocketConnectionsTable-prod", region: REGION },
    { tableName: "StrategiesTable-prod", region: REGION },
    { tableName: "Tickers-prod", region: REGION },
    { tableName: "UsersTable-prod", region: REGION },
    { tableName: "UtilityTable-prod", region: REGION },
  ],
};
